/**
 * API client for Bedrock metrics endpoints.
 * Routes: /api/mgmt/metrics
 */

import { apiFetch } from './client';

// ---------------------------------------------------------------------------
// Response types
// ---------------------------------------------------------------------------

export interface MetricTimeSeries {
  timestamps: string[];
  values: number[];
}

export interface ModelMetrics {
  Invocations: MetricTimeSeries;
  InputTokenCount: MetricTimeSeries;
  OutputTokenCount: MetricTimeSeries;
  InvocationLatency: MetricTimeSeries;
  InvocationThrottles: MetricTimeSeries;
  InvocationClientErrors: MetricTimeSeries;
  InvocationServerErrors: MetricTimeSeries;
}

export interface ModelConfig {
  modelId: string;
  label: string;
  color: string;
}

export interface ModelSummary {
  invocations: number;
  inputTokens: number;
  outputTokens: number;
  avgLatencyMs: number;
  throttles: number;
  errors: number;
}

export interface BedrockMetricsResponse {
  models: string[];
  modelConfig: ModelConfig[];
  period: number;
  hours: number;
  startTime: string;
  endTime: string;
  metrics: Record<string, ModelMetrics>;
  summary: Record<string, ModelSummary>;
}

// ---------------------------------------------------------------------------
// API functions
// ---------------------------------------------------------------------------

export async function getBedrockMetrics(
  token: string,
  hours?: number,
  period?: number,
): Promise<BedrockMetricsResponse> {
  const params = new URLSearchParams();
  if (hours !== undefined) params.set('hours', String(hours));
  if (period !== undefined) params.set('period', String(period));

  const qs = params.toString();
  const path = `/api/mgmt/metrics${qs ? `?${qs}` : ''}`;

  return apiFetch<BedrockMetricsResponse>(path, token);
}
